import React, { useState } from "react";
import Modal from "@mui/material/Modal";
import MDInput from "components/MDInput";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import Box from "@mui/material/Box";
import { useAuth } from "context";
import PropTypes from "prop-types";
import MDTypography from "components/MDTypography";
import SimpleBackdrop from "components/MDLoader_Backdrop";
import { Close } from "@mui/icons-material";

const UpdatePasswordModal = ({
  open,
  onConfirm,
  loader,
  userEmail,
  userPassword,
  handleClose,
  setLoader,
  setUserPassword,
  spinner,
  removeOnClose,
  forgotPassword,
  title,
}) => {
  const { darkMode } = useAuth();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "400px",
    maxWidth: "400px",
    bgcolor: !darkMode ? "#fff" : "#202940",
    boxShadow: 10,
    p: "24px",
    borderRadius: "12px",
    "@media (max-width:767px)": {
      width: "90%",
      padding: `18px`,
    },
  };

  const handleFormFieldChange = (event) => {
    const { name, value } = event.target;
    if (name === "confirmPassword") {
      setConfirmPassword(value);
      if (value !== newPassword) {
        setConfirmPasswordError("Confirm Password must be same as new password");
        setLoader(false);
      } else {
        setConfirmPasswordError("");
      }
    } else if (name === "newPassword") {
      setConfirmPassword("");
      setNewPassword(value);
      if (value.trim().length < 6) {
        setPasswordError("Password should be at least 6 characters.");
      } else {
        setPasswordError("");
      }
    }
  };

  return (
    <>
      <Modal
        open={open}
        onClose={removeOnClose ? null : handleClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <Box sx={style}>
          <MDBox
            sx={{
              display: "flex",
              alignItems: "start",
              justifyContent: "space-between",
              height: "45px",
            }}
            mb={3}
            textAlign="center"
          >
            {!removeOnClose && !forgotPassword && (
              <MDTypography sx={{ fontSize: "18px", color: "#181D27" }} fontWeight="medium">
                Update Password
              </MDTypography>
            )}
            {forgotPassword && !title && (
              <MDTypography sx={{ fontSize: "18px", color: "#181D27" }} fontWeight="medium">
                Set Password
              </MDTypography>
            )}
            {title && (
              <MDTypography sx={{ fontSize: "18px", color: "#181D27" }} fontWeight="medium">
                {title}
              </MDTypography>
            )}

            <div style={{ cursor: "pointer" }} onClick={handleClose}>
              <Close />
            </div>
          </MDBox>

          <card>
            <MDBox sx={{ display: "flex", gap: "12px", flexDirection: "column" }}>
              <div>
                <MDTypography
                  sx={{
                    mb: "6px",
                    lineHeight: "20px",
                    color: "#414651",
                    fontSize: "14px",
                    fontWeight: 500,
                  }}
                >
                  Email
                </MDTypography>
                <MDInput
                  required
                  type="email"
                  name="email"
                  variant="outlined"
                  fullWidth
                  value={userEmail}
                  disabled={true}
                />
              </div>

              <div>
                {!removeOnClose && !forgotPassword && (
                  <>
                    <MDTypography
                      sx={{
                        mb: "6px",
                        lineHeight: "20px",
                        color: "#414651",
                        fontSize: "14px",
                        fontWeight: 500,
                      }}
                    >
                      Current Password.
                    </MDTypography>
                    <MDInput
                      required
                      type="password"
                      name="yourPassword"
                      variant="outlined"
                      fullWidth
                      value={userPassword}
                      disabled={false}
                      onChange={(e) => {
                        setUserPassword(e.target.value);
                      }}
                    />
                  </>
                )}
              </div>

              <div>
                <MDTypography
                  sx={{
                    mb: "6px",
                    lineHeight: "20px",
                    color: "#414651",
                    fontSize: "14px",
                    fontWeight: 500,
                  }}
                >
                  New password
                </MDTypography>
                <MDInput
                  required
                  type="password"
                  name="newPassword"
                  variant="outlined"
                  fullWidth
                  value={newPassword}
                  disabled={false}
                  onChange={(e) => {
                    handleFormFieldChange(e);
                  }}
                  error={!!passwordError}
                  helperText={passwordError}
                />
              </div>

              <div>
                <MDTypography
                  sx={{
                    mb: "6px",
                    lineHeight: "20px",
                    color: "#414651",
                    fontSize: "14px",
                    fontWeight: 500,
                  }}
                >
                  Confirm new password
                </MDTypography>
                <MDInput
                  required
                  type="password"
                  name="confirmPassword"
                  variant="outlined"
                  fullWidth
                  value={confirmPassword}
                  disabled={false}
                  error={!!confirmPasswordError}
                  helperText={confirmPasswordError}
                  onChange={(e) => {
                    handleFormFieldChange(e);
                  }}
                />
              </div>
            </MDBox>

            <MDBox mt={"32px"} sx={{ display: "flex", gap: 2, justifyContent: "space-between" }}>
              {!removeOnClose && (
                <MDButton
                  fullWidth
                  variant="outlined"
                  color={"secondary"}
                  size="medium"
                  onClick={handleClose}
                  sx={{
                    borderRadius: "8px",
                    textTransform: "none",
                    fontSize: "16px",
                    fontWeight: 500,
                  }}
                >
                  {"Cancel"}
                </MDButton>
              )}
              <MDButton
                fullWidth
                variant="gradient"
                color={"success"}
                size="medium"
                disabled={
                  !newPassword ||
                  !confirmPassword ||
                  (!removeOnClose && !forgotPassword && !userPassword) ||
                  passwordError ||
                  confirmPasswordError ||
                  loader
                }
                onClick={() => onConfirm(newPassword)}
                sx={{
                  borderRadius: "8px",
                  textTransform: "none",
                  fontSize: "16px",
                  fontWeight: 500,
                }}
              >
                {"Update"}
              </MDButton>
            </MDBox>
          </card>
        </Box>
      </Modal>
      {spinner && <SimpleBackdrop />}
    </>
  );
};
UpdatePasswordModal.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "light",
    "dark",
  ]),
  title: PropTypes.string,
  handleClose: PropTypes.func,
  open: PropTypes.bool,
  userEmail: PropTypes.string,
  onConfirm: PropTypes.func,
  loader: PropTypes.bool,
  userPassword: PropTypes.string,
  setLoader: PropTypes.func,
  setUserPassword: PropTypes.func,
  spinner: PropTypes.bool,
  removeOnClose: PropTypes.bool,
  forgotPassword: PropTypes.bool,
};

export default UpdatePasswordModal;
